import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationResolver } from '../_shared/resolver/authentication.resolver';
import { CmaComponent } from './cma.component';
import { ComparablesRecommendationsComponent } from './comparables-recommendations/comparables-recommendations.component';
import { ViewCmaReportComponent } from './view-cma-report/view-cma-report.component';

const routes: Routes = [
  {
    path: '',
    component: CmaComponent,
    resolve: { AuthenticationResolver },
  },
  {
    path: 'view',
    component: ViewCmaReportComponent,
    resolve: { AuthenticationResolver },
  },
  {
    path: 'edit',
    component: ComparablesRecommendationsComponent,
    resolve: { AuthenticationResolver },
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule],
})
export class CmaRoutingModule { }
